import AnimatedKPI from "components/AnimatedKPI";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getValorTotal } from "services/dashboard";

const ShowTotal = () => {
  const { t } = useTranslation("dashboard");

  const [totalValue, setTotalValue] = useState<number>(0);

  useEffect(() => {
    getValorTotal().then((res) => {
      setTotalValue(Number(res?.total ?? 0) || 0);
    });
  }, []);
  return (
    <AnimatedKPI title={t("chart_titles.total_sellings")} value={totalValue} />
  );
};

export default ShowTotal;
